import {useQuery} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import {getLocalStorage} from '@/Utils/CommonUtils';

export type TicketStatus = 'Resolved' | 'In progress' | 'Not Seen' | null;

export interface Ticket {
  id: number;
  title: string;
  status: TicketStatus;
  user_unread_count: number;
  category: string;
  created_at: string;
  last_updated: string;
}

interface ApiResponse {
  status: 'success' | 'error';
  data: Ticket[];
}

interface GetTicketsPayload {
  userKey: string;
  from_date?: string;
  status?: TicketStatus;
  enabled?: boolean;
}

export function useGetUserTickets({
  userKey,
  from_date = '2025-10-31',
  status = null,
  enabled = true,
}: GetTicketsPayload) {
  return useQuery({
    enabled: !!userKey && enabled,
    queryKey: ['userTickets', userKey, from_date, status],
    queryFn: async (): Promise<Ticket[]> => {
      const token = await getLocalStorage('access_token');

      const params = new URLSearchParams({
        user_key: userKey,
        from_date,
        ...(status ? {status} : {}),
      }).toString();

      const response = await ChessRestClient.get<ApiResponse>(
        `/user_raised_issues/tickets?${params}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        },
      );

      if (response.data.status !== 'success') {
        throw new Error('Failed to fetch tickets');
      }

      return response.data.data;
    },
    // staleTime: 1000 * 60 * 2,
    // refetchOnWindowFocus: false,
  });
}
